import { render, staticRenderFns } from "./ShopeeCategoryMap.vue?vue&type=template&id=0c8215ff&"
import script from "./ShopeeCategoryMap.vue?vue&type=script&lang=js&"
export * from "./ShopeeCategoryMap.vue?vue&type=script&lang=js&"
import style0 from "./ShopeeCategoryMap.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports